import { Component, Input } from '@angular/core';
import { SurveySidebarSection } from '../survey-sidebar/survey-sidebar.component';

@Component({
  selector: 'survey-content-container',
  templateUrl: './survey-content-container.component.html',
  styleUrls: ['./survey-content-container.component.scss']
})
export class SurveyContentContainerComponent {
  @Input() sidebarSectionRoutes: SurveySidebarSection[] = []
  @Input() sidebarClass = '';
  @Input() sidebarCollapsed = false;
  @Input() sidebarCollapsable = true;
}
